import React from 'react'
import PropTypes from 'prop-types'
import {
  NoRealtimeWrapper,
  TheoreticalTime,
  TheoreticalTimeWrapper,
} from '../containers/Passages.styles'
import NoRealtimeIcon from './NoRealtimeIcon'

const NoRealtimeIrtis = ({
  departureTimeColor,
  theoreticalTime,
  noRealtimeCopy,
  isPreSubway,
  lightMode,
}) => {
  return (
    <div data-testid="irtis-no-realtime">
      <NoRealtimeWrapper
        color={lightMode ? '#666666' : '#B6B6B6'}
        isPreSubway={isPreSubway}
      >
        <NoRealtimeIcon />
        <span>{noRealtimeCopy}</span>
      </NoRealtimeWrapper>
      <TheoreticalTimeWrapper>
        <TheoreticalTime color={departureTimeColor} isPreSubway={isPreSubway}>
          {theoreticalTime}
        </TheoreticalTime>
      </TheoreticalTimeWrapper>
    </div>
  )
}

NoRealtimeIrtis.propTypes = {
  departureTimeColor: PropTypes.string,
  theoreticalTime: PropTypes.string,
  noRealtimeCopy: PropTypes.string,
  isPreSubway: PropTypes.bool.isRequired,
  lightMode: PropTypes.bool.isRequired,
}

export default NoRealtimeIrtis
